/* Point at a size, see that size drawn. */
if (!customElements.get('atlas-size-family')) {
  customElements.define(
    'atlas-size-family',
    class AtlasSizeFamily extends HTMLElement {
      connectedCallback() {
        this.wireGuide();
        this.figures = [...this.querySelectorAll('[data-atlas-scale]')];
        this.chips = [...this.querySelectorAll('[data-atlas-rung]')];
        if (this.figures.length < 2 || !this.chips.length) return;

        this.defaultIndex = this.figures.findIndex((f) =>
          f.classList.contains('atlas-scale--active')
        );
        if (this.defaultIndex < 0) this.defaultIndex = 0;

        this.chips.forEach((chip) => {
          const i = Number(chip.dataset.atlasRung);
          chip.addEventListener('mouseenter', () => this.show(i));
          chip.addEventListener('focus', () => this.show(i));
          chip.addEventListener('blur', () => this.reset());
        });

        // One listener for leaving the whole group, rather than one per chip, so moving
        // between two chips does not flicker back to the default in between.
        this.addEventListener('mouseleave', () => this.reset());
      }

      /* The size guide opens as a panel over the column, so it closes the way a panel does. */
      wireGuide() {
        const guide = this.querySelector('.atlas-sizefam__guide');
        if (!guide || guide.dataset.atlasWired) return;
        guide.dataset.atlasWired = 'true';
        document.addEventListener('click', (event) => {
          if (guide.open && !guide.contains(event.target)) guide.open = false;
        });
        const close = guide.querySelector('[data-atlas-guide-close]');
        if (close) {
          close.addEventListener('click', () => {
            guide.open = false;
            const summary = guide.querySelector('summary');
            if (summary) summary.focus();
          });
        }
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !guide.open) return;
          guide.open = false;
          const summary = guide.querySelector('summary');
          if (summary) summary.focus();
        });
      }

      show(index) {
        if (index === this.current) return;
        this.current = index;
        this.figures.forEach((f, i) => {
          f.hidden = i !== index;
        });
      }

      reset() {
        this.show(this.defaultIndex);
      }
    }
  );
}
